import React from 'react'
import { Box, Grid, makeStyles, Typography, Avatar, Hidden } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  box1: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: "50px"
  },
  box2: {
    justifyContent: "center",
    alignItems: "center",
  },
  darkBlueBox: {
    backgroundColor: theme.colors.blue,
  },
  white: {
    color: theme.colors.white,
    fontFamily: theme.font.fontFamily,
  },
  socialAvatars: {

    color: "#E04A00",
    '&:hover': {
      color: theme.colors.blue,
    }
  },

  floatingBtn: {
    borderRadius: "26.5px",
    backgroundColor: "#001F61",
    border: "1px solid #001F61",
    boxShadow: "0 16px 22px -17px #03153B",
    color: "#FF5805",
    cursor: "pointer",
    fontSize: "16px",
    lineHeight: "20px",
    padding: "12px 20px",
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: "999",
  },
  connecting: {
    borderRadius: "26.5px",
    backgroundColor: "#001F61",
    border: "1px solid #001F61",
    boxShadow: "0 16px 22px -17px #03153B",
    color: "#FF5805",
    cursor: "pointer",
    fontSize: "16px",
    lineHeight: "20px",
    padding: "12px 20px",
    position: "fixed",
    bottom: "20px",
    right: "10rem",
    zIndex: "999",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      right: "4rem"
    }
  },
  socialPanel: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 16px 31px -17px rgba(0,31,97,0.6)",
    border: "5px solid #001F61",
    flexirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: 'Muli',
    position: "relative",
    height: "169px",
    width: "370px",
    maxWidth: "calc(100% - 10px)"
  },

  closeBtn: {
    border: "0",
    color: "#97A5CE",
    cursor: "pointer",
    fontSize: "20px",

    position: "absolute",
    bottom: "5px",
    right: "2px",
  },
  ulList: {
    display: "flex",
    listStyleType: "none",
    padding: "0",
    margin: "0",
    justifyContent: "center"

  }
  ,
  li: {
    margin: "0 10px"
  },
  al: {
    border: "1px solid #DCE1F2",
    borderRadius: "50%",
    color: "#001F61",
    fontSize: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: " 50px",
    width: "50px",
    textDecoration: "none"
  },
  Heading: {
    margin: " 20px 0",
    color: "#97A5CE",
    fontFamily: 'Muli',
    fontSize: "14px",
    lineHeight: "18px",
    textTransform: "uppercase",
    textAlign: "center"
  },
  socialpanelcontainer: {
    visibility: "visible",
    position: "fixed",
    zIndex: 13000,
    bottom: "5rem",
    transform: "translateX(0)",
    transition: "transform 0.4s ease-in-out",
  },
  socialpanelcontainerFalse: {
    visibility: "visible",
    position: "fixed",
    bottom: "5rem",
    transform: "translateX(121%)",
    transition: "transform 0.4s ease-in-out",
  }

}));





function Footer({ ConnectToWallet }) {
  const classes = useStyles();
  const [togle, setTogle] = React.useState(false)


  const ToggleHandler = () => {

    setTogle((prevState) => ({
      togle: !prevState.togle
    }));


  }



  let attachedClasses = [classes.closeBtn, classes.socialpanelcontainer];
  if (togle.togle === false) {
    attachedClasses = [classes.closeBtn, classes.socialpanelcontainerFalse];
  }
  return (
    <>
      <Hidden smDown>
        <Grid container style={{ display: "flex", justifyContent: "flex-end" }}>
          <div class={togle.togle == true ? classes.socialpanelcontainer : classes.socialpanelcontainerFalse}>
            <div className={classes.socialPanel}>
              <h4 className={classes.Heading}  >Get in touch on</h4>


              <ul className={classes.ulList}>
                <li className={classes.li}>
                  <a className={classes.al} href="https://www.patreon.com/florinpop17" target="_blank">
                    <i class="fab fa-discord"></i>
                  </a>
                </li>
                <li>
                  <a className={classes.al} href="https://twitter.com/florinpop1705" target="_blank">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a className={classes.al} href="https://linkedin.com/in/florinpop17" target="_blank">
                    <i class="fab fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a className={classes.al} href="https://facebook.com/florinpop17" target="_blank">
                    <i class="fab fa-facebook"></i>
                  </a>
                </li>
                <li>

                  <a className={classes.al} href="https://instagram.com/florinpop17" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
              <button className={classes.closeBtn} onClick={ToggleHandler} ><i class="fas fa-times"></i></button>
            </div>
          </div>

        </Grid>
      </Hidden>
      <Box className={classes.darkBlueBox}>
        <Hidden smDown>
          <button className={classes.floatingBtn} onClick={ToggleHandler} >
            Get in Touch
         </button>
        </Hidden>
        <button className={classes.connecting} onClick={ConnectToWallet}>
          <i class="fas fa-wallet"></i>  Connectt wallet
        </button>

        <Box maxWidth="1248px" mx="auto" py="10px" className={classes.darkBlueBox} p="10px">
          <Grid container className={classes.box1} spacing={2} justifyContent="space-between" direction="row-reverse" xs={12} >
            <Grid item container className={classes.box2} justifyContent="space-between" xs={12} sm={6}  >
              <Avatar style={{ marginRight: "20px" }}>
                <a href="https://www.facebook.com"><i className={classes.socialAvatars + " " + "fab fa-facebook-f"}></i></a>
              </Avatar>
              <Avatar style={{ marginRight: "20px" }}>
                <a href="https://www.facebook.com"><i className={classes.socialAvatars + " " + "fab fa-twitter"}></i></a>
              </Avatar>
              <Avatar style={{ marginRight: "20px" }}>
                <a href="https://www.facebook.com"><i className={classes.socialAvatars + " " + "fab fa-instagram"}></i></a>
              </Avatar>
            </Grid>
            <Grid item container className={classes.box2} justifyContent="space-between" xs={12} sm={6}   >
              <Typography variant="body1" style={{ marginRight: "20px" }} className={classes.white}><a href="" className={classes.white}>Disclaimer</a></Typography>
              <Typography variant="body1" style={{ marginRight: "20px" }} className={classes.white}><a href="" className={classes.white}>Privacy Policy</a></Typography>
              <Typography variant="body1" style={{ marginRight: "20px" }} className={classes.white}><a href="" className={classes.white}>Cookie Policy</a></Typography>
            </Grid>
            <Grid item className={classes.box2} xs={12} sm={12}   >
              <Typography variant="body1" style={{ marginRight: "20px" }} className={classes.white}>Copyright © 2015-2021 Blockchain Intelligence Group. All rights reserved.</Typography>

            </Grid>
          </Grid>

        </Box>
      </Box>
    </>
  )
}

export default Footer
